<template>
  <van-popup position="bottom" v-model="show">
    <van-area
      :area-list="areaList"
      :columns-num="3"
      @confirm="onConfirm"
      @cancel="cancel"
    />
  </van-popup>
</template>

<script>
import { areaList } from "@/utils/area.js";
import { Area } from "vant";

export default {
  data() {
    return {
      areaList,
      show: false,
    };
  },
  props: {

  },
  methods: {
    onConfirm(data) {
      this.$emit("onConfirm", data);
      this.show = false
    },
    cancel() {
      this.$emit("onCancel")
      this.show = false
    },
  },
  components: {
    [Area.name]: Area
  }
};
</script>
